import { authModalTabs } from "components/UI/Popups/AuthPopup";
import { onOpenAuthPopup } from "components/popups/PopupDispatcher";

import IMAGE from "images/login-bg.jpg";

import "./LoginSplash.scss";

export const LoginSplash = (): JSX.Element => {

  const onLogin = () => {
    onOpenAuthPopup({ tab: authModalTabs.login });
  };

  const onSignUp = () => {
    onOpenAuthPopup({ tab: authModalTabs.signup });
  };

  return (
    <div className="loginSplash center">
      <img className="bg" src={IMAGE} alt="Poster for splash page" />

      <div className="screen"></div>

      <div className="wrapper">
        <p>You must be logged in to view<br/>the “For You” feed.</p>

        <button
          className="login button"
          onClick={onLogin}
          aria-label="login button"
        >Log In</button>

        <hr/>

        <p>Don't have an account?</p>

        <p>
          <button className="signUp" onClick={onSignUp} aria-label="sign up button">Sign Up</button>
        </p>
      </div>
    </div>
  );
};
